import { getCountryList } from '@topconagriculture/country';
import { getLoader } from '@topconagriculture/loader';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import { isPristine, isValid, submit } from 'redux-form';
import { ProfilingForms, ProfilingLoaders } from '../../config';
import { getUserCompany, updateCompany, getTenantSettings } from '../../store';
import CompanyModal from './CompanyModal';
const formId = ProfilingForms.editCompany;
const mapStateToProps = (state) => {
    const isFetchingCompany = getLoader(state)(ProfilingLoaders.fetchCompany);
    const isUpdatingCompany = getLoader(state)(ProfilingLoaders.updatingCompany);
    const isLoadingTenantSettings = getLoader(state)(ProfilingLoaders.fetchTenantsSettings);
    return {
        disabled: !isValid(formId)(state) || isPristine(formId)(state),
        company: getUserCompany(state),
        countries: getCountryList(state),
        isLoading: isFetchingCompany || isUpdatingCompany || isLoadingTenantSettings,
        tenantSettings: getTenantSettings(state),
    };
};
const mapDispatchToProps = (dispatch) => bindActionCreators({
    onCompanyUpdate: updateCompany.started,
    submit,
}, dispatch);
export default compose(connect(mapStateToProps, mapDispatchToProps))(CompanyModal);
//# sourceMappingURL=CompanyModalContainer.js.map